<template>
  <div class="xcard">
      <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
    <h3 class="text-primary text-center">Instituciones</h3>
    <button class="btn btn-link btn-sm" @click="editar({})" v-show="$store.state.createInstitucion" data-toggle="modal" data-target="#newIns"> <span class="glyphicon glyphicon-plus"></span> Institucion </button> 

    <div class="table-responsive">
        <input v-show="datos.length" type="text" style="border:1px solid #1177d1;background:#fefefe" v-model="buscar" placeholder="Buscar...">                
      <table class="table table-hover" id="midatatable">
        <thead>
          <tr>
            <th>Nro</th>
            <th>Nombre</th>
            <th>Abreviatura</th>
            <th>Tipo</th>
            <th>Convenio</th>
            <th>Opciones</th>
          </tr>
        </thead>

        <tbody>
          <tr v-bind:key="ind" v-for="(sede, ind) in datos">
            <td>{{ ind + 1 }}</td>
            <td :title="'id:' + sede.id">{{ sede.nombre }}</td>
            <td>{{ sede.abreviatura }}</td>
            <td>{{ sede.tipo }}</td>
            <td>{{ sede.convenio }}</td>
            <td style="min-width: 90px">
                <button class="btn btn-sm btn-link" @click="editar(sede)" v-show="$store.state.updateInstitucion" data-toggle="modal" data-target="#newIns"> <span class="glyphicon glyphicon-pencil"></span> </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <Alertas ref="alertar" />
    <newIns id="newIns" v-on:exito="modalExitof" :edit="seleccionado"/>
  </div>
</template>



<script>
import gql from 'graphql-tag';
import { parseJsonError } from '@/components/Utils.js';
import Alertas from '@/components/AAlertas.vue';
import newIns from '@/components/ANewInstitucion.vue'

export default {
  data() {
    return {
        seleccionado:{},
      datos: [],
      buscar:'',
    };
  },
  components: { Alertas,newIns },
  watch: {
    'buscar': function(){ this.myFunction1( this.buscar.trim() ) }
  },
  methods: {
      editar( obj ){
          this.seleccionado = obj;
      },
      modalExitof(){
          this.getDatos();
        },
    async getDatos() {
      this.$refs.alertar.cargando();
      var vue = this;
      var sql = gql`
      query{
        getInstituciones(estado:true){ id,nombre,tipo,estado,nombre,convenio,abreviatura}
        }`;
      await this.$apollo
        .query({
          query: sql,
        })
        .then(({data}) => {
          vue.datos = data.getInstituciones;
          vue.$refs.alertar.reset();
        })
        .catch((error) => {
          // window.console.error(error);
          vue.$notify(parseJsonError(error, 'getInstituciones'));
          vue.$refs.alertar.reset();
        });
    },
    myFunction1( filtro ) {
            filtro = filtro.toUpperCase();
            var table, tr, tdd,td, i,j, txtValue;
            table = document.getElementById("midatatable");
            tr = table.getElementsByTagName("tr");

            for (i = 0; i < tr.length; i++) {
                tdd = tr[i].getElementsByTagName("td");
                for(j = 1; j< tdd.length;j++) {
                    td = tdd[j];
                    if (td) {
                        txtValue = td.textContent;
                        if (txtValue.toUpperCase().indexOf(filtro) > -1) {
                            tr[i].style.display = "";
                            break;
                        } else {
                            tr[i].style.display = "none";
                        }
                    } 
                }
            }
		},
  },
  mounted() {
    this.getDatos();
  },
};
</script>